module.exports = __webpack_public_path__ + "assets/img/搜索商品.f5e5fb24.jpg";